/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="89.25"
        height="95.58"
        viewBox="0 0 89.25 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#fff"
          d="M45.33 77.84a8.87 8.87 0 1 0 8.87 8.87 8.87 8.87 0 0 0-8.87-8.87Zm0 2.5a6.37 6.37 0 1 1-6.32 6.42v-.05a6.37 6.37 0 0 1 6.32-6.37ZM78.1 53.35a11.16 11.16 0 1 0 11.15 11.17A11.15 11.15 0 0 0 78.1 53.37Zm0 2.5a8.66 8.66 0 1 1-8.66 8.66 8.66 8.66 0 0 1 8.66-8.66ZM10.41 53.21a10.4 10.4 0 1 0 10.4 10.41 10.4 10.4 0 0 0-10.38-10.4Zm0 2.5a7.9 7.9 0 1 1-7.9 7.9 7.9 7.9 0 0 1 7.9-7.9ZM75.81 7.62a7.35 7.35 0 1 0 7.35 7.35 7.36 7.36 0 0 0-7.35-7.35Zm0 2.5a4.85 4.85 0 1 1-4.8 4.9v-.05a4.85 4.85 0 0 1 4.8-4.85ZM20.18 0a12.68 12.68 0 1 0 12.68 12.68A12.68 12.68 0 0 0 20.18 0Zm0 2.5a10.18 10.18 0 1 1-10.17 10.19A10.18 10.18 0 0 1 20.18 2.5Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M46.58 57.29v21.8h-2.5v-21.8ZM32.81 47.82l1.47 2-14.1 10.35-1.47-2ZM57.81 49.46l12.86 8.3-1.36 2.1-12.86-8.3ZM69.81 17.52l1.66 1.87-15.19 13.5-1.66-1.87ZM29.49 20.23l8.33 9.2-1.86 1.67-8.33-9.2Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M45.33 27.44a15 15 0 1 0 15 15 15 15 0 0 0-15-15Zm0 2.5a12.47 12.47 0 1 1-12.47 12.47 12.47 12.47 0 0 1 12.47-12.47Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'FiveConnectedNodesIcon';

export default Icon;
